import { render } from "./NudgeMessage.vue?vue&type=template&id=2db17ac8"
import script from "./NudgeMessage.vue?vue&type=script&lang=js"
export * from "./NudgeMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__